import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import { insideItems } from '../data/gallery';
const imagine = ['Imagine explaining forklift stability using a detailed equipment diagram.', 'Showing excavator hydraulic components with enlarged mechanical illustrations.', 'Comparing bulldozers, wheel loaders and motor graders side by side.', 'Teaching crane anatomy through professional technical reference sheets.', 'Helping students identify elevated-workplace hazards through realistic industrial scenarios.', 'Or explaining road construction equipment using complete visual worksite illustrations.'];
export function VisualSection() {
  return <section className="py-20 px-4 bg-white" data-id="element-334" data-mp="3l7z7rywiule0">
      <div className="max-w-5xl mx-auto" data-id="element-335" data-mp="3l90mqegnrs10">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="grid md:grid-cols-[1fr_1.4fr] gap-8 md:gap-12 items-start" data-id="element-336" data-mp="36azsrpzcbq9i">
          <div data-id="element-337" data-mp="9t0ms92scrc2">
            <h2 className="text-3xl md:text-4xl font-bold tracking-tight mb-5 text-neutral-900 uppercase" data-id="element-338" data-mp="9rfr2g4qj2cm">
              See What You&apos;re Teaching
            </h2>
            <p className="text-xl font-semibold text-neutral-900 mb-1" data-id="element-339" data-mp="jqy7wnpcm80g">
              Heavy Equipment Training Is Visual.
            </p>
            <p className="text-xl font-semibold text-amber-600 mb-5" data-id="element-340" data-mp="3s79ueqw59c2m">
              Your Teaching Materials Should Be Visual Too.
            </p>
            <div className="space-y-3 text-neutral-800 leading-relaxed" data-id="element-341" data-mp="3n5khf5pd2obw">
              <p data-id="element-342" data-mp="4upalrp0q4qo">{imagine.join(' ')}</p>
              <p className="font-semibold text-neutral-900" data-id="element-343" data-mp="2xvcdbbblfu">
                That&apos;s the advantage of a 100% visual training system.
              </p>
              <p data-id="element-344" data-mp="38gxzqxc9hkhi">
                <span className="font-semibold text-neutral-900" data-id="element-345" data-mp="38gemvv1gxmac">Heavy Equipment Instructor Atlas</span>{' '}
                is built around machinery illustrations, technical diagrams, equipment comparisons,
                workplace scenarios, instructor exercises and professional reference tools.
              </p>
            </div>
          </div>

          <div className="bg-neutral-100 border border-neutral-200 rounded-2xl p-6" data-id="element-346" data-mp="1h74av6mxkytl">
            <p className="text-sm font-bold text-neutral-900 uppercase tracking-wider mb-4" data-id="element-347" data-mp="1m5pezh5b02nb">
              Inside you’ll find:
            </p>
            <ul className="grid sm:grid-cols-2 gap-x-4 gap-y-2.5" data-id="element-348" data-mp="oj8haasnrn11">
              {insideItems.map(item => <li key={item} className="flex items-start gap-2 text-sm text-neutral-800" data-id="element-349" data-mp="til4iwnfyw45">
                  <CheckCircle2 size={16} className="text-amber-500 shrink-0 mt-0.5" data-id="element-350" data-mp="yho8sevlkyb2" />
                  <span data-id="element-351" data-mp="13g9728rah7wv">{item}</span>
                </li>)}
            </ul>
          </div>
        </motion.div>

        <p className="text-center text-2xl md:text-4xl font-extrabold tracking-tight text-neutral-900 mt-14" data-id="element-352" data-mp="29x331awf9c2h">
          <span className="text-amber-600" data-id="element-353" data-mp="36hxbm9g1ly3">100% VISUAL.</span> PRACTICAL. PROFESSIONAL. BUILT TO TEACH.
        </p>
      </div>
    </section>;
}